import { render } from "./PropertyRequest.vue?vue&type=template&id=48f2d5e9"
import script from "./PropertyRequest.vue?vue&type=script&lang=js"
export * from "./PropertyRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__